import { Stack, Typography, useTheme } from "@mui/material";
import { Calendar, Inbox } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { EmptyTimelineStateProps } from "web_myplann/NotificationCenter/Types/EmptyTimelineStateProps";
import { EmptyTimelineVariant } from "web_myplann/NotificationCenter/Types/EmptyTimelineVariant";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

const ICON_SIZE = 28;

export const EmptyTimelineV2State: FC<EmptyTimelineStateProps> = ({
	variant,
}) => {
	const { t } = useResource();
	const { palette, radii, spacingTokens, notificationCenter } = useTheme();
	const texts = Resources.NotificationCenter.EmptyState;
	const isUpcoming = variant === EmptyTimelineVariant.Upcoming;
	const Icon = isUpcoming ? Calendar : Inbox;
	const copy = isUpcoming ? texts.Upcoming : texts.Recent;

	return (
		<Stack
			flex={1}
			alignItems="center"
			justifyContent="center"
			textAlign="center"
			px={spacingTokens.xxl}
			py={spacingTokens.xxl}
			data-testid={`notification-center-empty-${variant}`}
		>
			<IconBox
				bg={palette.grey[100]}
				size={notificationCenter.emptyIconBoxSize}
				borderRadius={radii.xl}
				mb={spacingTokens.lg}
			>
				<Icon aria-hidden size={ICON_SIZE} color={palette.grey[400]} />
			</IconBox>
			<Typography variant="bodyStrong" color={palette.grey[700]}>
				{t(copy.title)}
			</Typography>
			<Typography variant="hint" mt={spacingTokens.xs}>
				{t(copy.description)}
			</Typography>
		</Stack>
	);
};
